import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Form from "../Signup/Form";
export default function Recovery() {
  return (
    <>
      <Header></Header>
      <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-full opacity-20 bg-login-bg bg-cover bg-center z-0"></div>
      <Form type="recovery"></Form>
      <Footer></Footer>
    </>
  );
}
